import { Component } from '@angular/core';
import { SupporterContactInfoModel } from '../../../../auth/models/supporter-contact-info.model';
import { ResponsiveMode } from '../../../models/responsive-mode.type';
import { SassHelperComponent } from '../../../providers/sass-helper/sass-helper.component';
import { BreakpointObserver } from '@angular/cdk/layout';
import { AuthFacade } from '../../../../auth/facade/auth.facade';
import { NetworkMonitorService } from '../../../services/network-monitor.service';

@Component({
  selector: 'morva-disconnection',
  templateUrl: './disconnection.component.html',
  styleUrls: ['./../error.scss'],
})
export class DisconnectionComponent {
  supporterContactInfo: SupporterContactInfoModel = {contactInfoType:'' ,email: '', phoneNumber: ''};
  responsiveMode: ResponsiveMode;
  private sassHelper: SassHelperComponent;

  constructor(private breakPointObserver: BreakpointObserver, private authFacade: AuthFacade,  private networkMonitorService: NetworkMonitorService
) {
    this.sassHelper = new SassHelperComponent();
  }

  ngOnInit(): void {
    this.breakPointObserver.observe([this.sassHelper.mdMaxWidth]).subscribe(state => {
      if (state.breakpoints[this.sassHelper.mdMaxWidth]) {
        this.responsiveMode = 'md';
      } else {
        this.responsiveMode = 'lg';
      }
    });
    this.getSupporterContactInfo();
    this.networkMonitorService.startMonitoring();
  }

  private getSupporterContactInfo() {
    this.authFacade.getSupporterContactInfo().subscribe(res => {
      this.supporterContactInfo = res;
    });
  }

}
